export default "__VITE_ASSET__7e90b1f8__"